import { Message } from "@twilio/conversations";
import { classNames } from "primereact/utils";
import { Formatter } from "../../../services/formatter/formatter.service";
import TwilioConversationService from "../../../services/twilio/twilio-conversations.service";

const ConversationMessage = ({
	message,
	members,
}: {
	message: Message;
	members: { [x: string]: string };
}) => (
	<div
		key={message.sid}
		className={classNames(
			"message-container",
			TwilioConversationService.isOwnMessage(message) ? "own-message" : "other-message"
		)}
	>
		{/* Message: author */}
		{!TwilioConversationService.isOwnMessage(message) && message.author && (
			<div className="message-container__author">
				{members[message.author] || message.author}
			</div>
		)}
		<div className="message-container__wrapper">
			{/* Message: body */}
			<div className="message-container__wrapper__body">{message.body}</div>

			{/* Message: creation date */}
			{message.dateCreated && (
				<div className="message-container__wrapper__date">
					{Formatter.date(message.dateCreated, {
						day: "numeric",
						month: "short",
						year: "numeric",
						hour: "2-digit",
						minute: "2-digit",
					})}
				</div>
			)}
		</div>
	</div>
);

export default ConversationMessage;
